module.exports = "<uoz-navigation>\n  <router-outlet></router-outlet>\n</uoz-navigation>\n\n"